import { useState } from 'react';
import { t } from '../../i18n/index.js';

/** Erster Schritt aus einer Vorlage: einmal sichtbar, bis man ihn wegklickt (je Person und Projekt, nur in diesem Browser) */
export function FirstStepHint({ projectId, text }: { projectId: string; text: string }) {
  const key = `werft.firstStep.${projectId}`;
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(key) === '1';
    } catch {
      return false;
    }
  });
  if (hidden) return null;
  return (
    <div role="note" data-first-step="" className="mb-3 flex items-start gap-2 rounded-xl border border-[var(--color-accent)]/40 bg-[var(--color-accent)]/5 px-3 py-2 text-sm">
      <span className="min-w-0 flex-1">
        <span className="font-medium">{t('firstStep.label')}: </span>
        {text}
      </span>
      <button
        type="button"
        onClick={() => {
          try {
            localStorage.setItem(key, '1');
          } catch {
            /* nur für diese Sitzung */
          }
          setHidden(true);
        }}
        aria-label={t('firstStep.dismiss')}
        className="grid size-10 shrink-0 place-items-center rounded-lg text-zinc-500 hover:bg-zinc-100 dark:hover:bg-zinc-800"
      >
        ×
      </button>
    </div>
  );
}
